import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setStateFromPayload } from "../navigoSlice";
import { logEvent, logEventWithData } from "../../../app/eventSlice";
import iIcon from "../../../assets/icons/iIcon.jpg";
import { useHistory } from "react-router-dom";
import {
  VideoIcon,
  PhoneIcon,
  UserIcon,
  HomeIcon,
  HospitalIcon,
} from "lucide-react";
import BookingForSection from "./bookingForSection";
import { getFamilyData, getPriceForFamily } from "../../familyInfo/familySlice";
import { InfoIcon, Check } from "lucide-react";
import { routeForServiceMode } from "../utils/routeByMode";

function ModeIcon({ modeName, size = 16 }) {
  switch (modeName) {
    case "Video consultation":
      return <VideoIcon size={size} />;
    case "Tele consultation":
      return <PhoneIcon size={size} />;
    case "In-person consultation":
      return <UserIcon size={size} />;
    case "Home sample":
      return <HomeIcon size={size} />;
    case "Centre visit":
      return <HospitalIcon size={size} />;
    default:
      return null;
  }
}

const GeneralNavigoCard = ({ handleGotoAddress, service, planId, pageType }) => {
  const navigoStore = useSelector((store) => store.navigo);
  const history = useHistory();
  const {
    familyMemberSelected,
    isForFamily,
    currentServices,
    familyMemberSelectedData,
    callHandleAvailNow,
  } = navigoStore.ui;
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile,
  );
  const [bookingFor, showBookingFor] = useState(false);
  const [isPricesFetched, setIsPricesFetched] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (callHandleAvailNow) {
      handleAvailNowContinue(null);
    }
  }, [callHandleAvailNow]);
  const handleAvailNowContinue = (service = null) => {
    if (!service) {
      service = { ...currentServices };
    }

    if (isForFamily) {
      if (service.addressRequired) {
        dispatch(
          setStateFromPayload({
            currentServices: { ...service },
            callHandleAvailNow: false,
          }),
        );
        handleGotoAddress(familyMemberSelected, familyMemberSelectedData);
      } else {
        dispatch(
          setStateFromPayload({
            currentServices: { ...service },
            currScreen: 3,
            callHandleAvailNow: false,
          }),
        );
      }
    } else {
      let fm = familyMemberSelected;
      if (familyMemberSelected !== -2) {
        if (familyMemberSelected === -1 && service.availedForObj[0]) {
          fm = -2;
        } else if (service.availedForObj[familyMemberSelected]) {
          fm = -2;
        }
      }
      // dispatch(
      //   setStateFromPayload({
      //     currentServices: { ...service },
      //     currScreen: 2,
      //     familyMemberSelected: fm,
      //     callHandleAvailNow: false,
      //   })
      // );
    }
  };

  const {
    imageMobile,
    name,
    description,
    discountedPrice,
    price,
    serviceTypeId,
    availed,
    availedForFamily,
    familyMemberCount,
    serviceModeDetails,
  } = service;

  // The card shows a single price — the cheapest mode's. When there is more
  // than one mode, the explicit per-mode prices are shown on the
  // mode-selection screen (after Continue).
  const modesList = serviceModeDetails || [];
  const displayMode = modesList.reduce(
    (cheapest, m) =>
      (m?.discountedPrice ?? Infinity) < (cheapest?.discountedPrice ?? Infinity)
        ? m
        : cheapest,
    modesList[0],
  );

  const handleContinue = () => {
    const modes = service?.serviceModeDetails || [];
    // Multiple modes: pick one on a dedicated screen first.
    if (modes.length > 1) {
      history.push({
        pathname: "/select-mode",
        state: { service, planId, pageType },
      });
      return;
    }
    routeForServiceMode({
      service,
      modeName: modes?.[0]?.modeName,
      planId,
      pageType,
      patientId: patientProfile.id,
      dispatch,
      history,
    });
  };

  // if (bookingFor && isPricesFetched) {
  //   return <BookingForSection service={service} />;
  // }

  return (
    !bookingFor && (
      <div className="navigo-general-card-container relative">
        {/* Info Icon - Top Right */}
        <div className="absolute top-3 right-3 z-10">
          <button
            onClick={() =>
              history.push({
                pathname: "/serviceDetails",
                state: { service, planId },
              })
            }
            className="p-0 m-0 bg-transparent border-none outline-none hover:text-gray-800"
          >
            <InfoIcon size={20} />
          </button>
        </div>

        {/* Card Top Content */}
        <div className="navigo-general-card-container-top">
          <div className="navigo-general-card-container-top-left">
            <img
              src={imageMobile}
              alt="card-img"
              className="w-24 h-24 object-cover rounded"
            />
          </div>

          <div className="navigo-general-card-container-top-right flex-1">
            <div className="flex flex-col justify-between h-full">
              <div>
                <p className="font-bold text-xl text-gray-900 m-0">{name}</p>
                <p className="text-sm text-gray-600 mt-1">{description}</p>

                {serviceModeDetails.map((serviceMode, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center gap-1 bg-sky-100 text-800 px-2 py-1 text-xs mt-3 mr-2 mb-0"
                  >
                    <ModeIcon modeName={serviceMode.modeName} />
                    {serviceMode.modeName}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Card Bottom Content */}
        <div className="navigo-general-card-container-bottom">
          <div className="navigo-general-card-container-top-right-bottom">
            <div className="navigo-general-card-container-top-right-bottom-price">
              {displayMode?.discountedPrice === 0 && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    marginRight: 8,
                    padding: "4px 10px",
                    backgroundColor: "#DCFCE7",
                    color: "#15803D",
                    borderRadius: 999,
                    fontSize: 11,
                    fontWeight: 700,
                    verticalAlign: "middle",
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                >
                  <Check size={13} strokeWidth={3} />
                  Sponsored
                </span>
              )}
              <span className="fw-semibold text-lg">
                ₹{displayMode?.discountedPrice}
              </span>{" "}
              {displayMode?.maxPrice && (
                <span className="font-strikethrough text-sm text-gray-400 ml-2">
                  ₹{displayMode.maxPrice}
                </span>
              )}
            </div>
          </div>

          <button
            className="navigo-general-card-container-bottom-book-now"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    )
  );
};

export default GeneralNavigoCard;
